$("form[data-form-submit-preventdefault]").submit(function (e) {
    e.preventDefault();
});

//submit form if the user uses the enter key
$('input[type=text], input[type=search], input[type=tel], input[type=email], input[type=password]').keypress(function (e) {
    if (e.which == 13) {
        $(this).closest("form").submit();
        return false;
    }
});

$('[data-form-clear-input-trigger]').on('click', function () {
    var sourceElementId = $(this).attr('data-form-clear-input-trigger');

    var $parentElement = $(this).closest('form');
    if (!$parentElement.length) {
        $parentElement = $(this).closest('.input-group');
    }

    var $inputs;

    if (sourceElementId) {
        var $sourceElement = $(sourceElementId);
        $inputs = $sourceElement.find(':input');
    } else {
        $inputs = $parentElement.find(':input');
    }

    // Clear the input values
    $inputs.each(function () {
        var $input = $(this);
        if ($input.is(':checkbox, :radio')) {
            if ($input[0].hasAttribute('data-form-default')) {
                $input.prop('checked', true);
            } else {
                $input.prop('checked', false);
            }
        } else {
            $input.val('');
        }

        // ?? Re-trigger input logic (e.g. filtering, visibility toggling)
        $input.trigger('input');
    });

    if ($parentElement.is('form')) {
        $parentElement.closest("form").submit();
    }
});


function isCheckBased(element) {
    var type = element.attr('type');
    return type === 'checkbox' || type === 'radio';
}

window.clearInputs = function clearInputs(inputElements) {
    $(inputElements).each(function (index) {
        if (isCheckBased($(this))) {
            if ($(this)[0].hasAttribute('data-form-default')) {
                $(this).prop('checked', true);
            }
            else {
                $(this).prop('checked', false);
            }
        }
        else {
            $(this).val('');
        }


    });
}

function toggleInputVisibility($input) {
    var selector = $input.attr('data-form-input-show');
    if (!selector) return;

    var $parentElement = $input.closest('form');
    if (!$parentElement.length) {
        $parentElement = $input.closest('.input-group');
    }

    var $target = $parentElement.find(selector);

    if ($input.val().trim() !== '') {
        $target.css('visibility', 'visible');
    } else {
        $target.css('visibility', 'hidden');
    }
}

$('[data-form-input-show]').on('input', function () {
    toggleInputVisibility($(this));
});

function serializeFormWithExclusions(form) {
    return $(form).find(':input').not('[data-form-exclude]').serialize();
}

// Replication of recipient-button behavior but with scroll offset for sticky header
(function () {
    $(document).ready(function () {
        const selector = 'button[data-recipient]';

        if ($(selector).length > 0 && $('form.bol-contact-question').length === 1) {

            // Remove any existing click handlers to prevent duplicate execution
            $(selector).off('click');

            $(selector).on('click', function () {
                var rcpt = $(this).data('recipient');
                var sel = 'form.bol-contact-question select option[value*="' + rcpt + '"]';

                if ($(sel).length === 0) {
                    sel = 'form.bol-contact-question select option[value*="helpdesk@bmhcc.org"]';
                }

                var option = $(sel).first();
                var selectBox = option.parent();

                if (selectBox.length === 0) return;

                // Update select box
                selectBox.find('option').prop('selected', false);
                option.prop('selected', true);

                // Scroll to the closest form with offset from dynamic header height
                var form = selectBox.closest('form');
                var headerHeight = $('#header').outerHeight() || 0;

                var scrollTarget = form.offset().top - headerHeight;
                console.log(scrollTarget);
                $('html, body').animate({
                    scrollTop: scrollTarget
                }, 200);
            });
        }
    });
})();

$(document).on("change", "[data-form-submit-on-change]", function () {
    $(this).closest("form").submit();
});

/* TODO - merge this with the existing 'data-input-clear' stuff */
/**
 * Handles search input clearer visibility and behavior.
 * Shows the clearer when the input has a value and hides it when empty.
 */
$(document).ready(function () {
    $('.input-clearer').each(function () {
        var $clearer = $(this);
        var $input = $clearer.closest('.input-group').find('input').first();

        // Set initial visibility, including server-side populated values.
        if ($input.val().trim().length > 0) {
            $clearer.show();
        } else {
            $clearer.hide();
        }

        // Update clearer visibility whenever the input changes.
        $input.on('input', function () {
            if ($(this).val().trim().length > 0) {
                $clearer.show();
            } else {
                $clearer.hide();
            }
        });

        // Clear the input and trigger its existing input functionality.
        $clearer.on('click', function () {
            $input
                .val('')
                .trigger('input')
                .focus();
        });
    });
});